<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">分级规则管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增规则</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column prop="weight" label="级别" width="60">
      </custom-table-column>
      <custom-table-column prop="level" label="风险等级" width="100">
      </custom-table-column>
      <custom-table-column prop="inspection_period" label="检查周期" width="100">
      </custom-table-column>
      <custom-table-column prop="safety_check" label="安全检查" min-width="220">
      </custom-table-column>
      <custom-table-column prop="safety_training" label="安全培训" min-width="220">
      </custom-table-column>
      <custom-table-column prop="safety_assessment" label="安全评估" min-width="220">
      </custom-table-column>
      <custom-table-column prop="safety_guarantee" label="安全保障" min-width="220">
      </custom-table-column>
      <!--<custom-table-column prop="protection_points" label="防护要点" min-width="220">
      </custom-table-column>
      <custom-table-column prop="special_equipment" label="特种设备" min-width="220">
      </custom-table-column>
      <custom-table-column prop="emergency_plan" label="应急预案" min-width="220">
      </custom-table-column>
      <custom-table-column prop="safety_facilities" label="安全设施" min-width="220">
      </custom-table-column> -->
      <!-- <custom-table-column label="警示图示" min-width="160">
        <template slot-scope="scope" v-if="scope.row.warning_signs">
          <el-image v-for="(item, index) in scope.row.warning_signs.split(',')" :key="index" :src="item"
            :preview-src-list="scope.row.warning_signs.split(',')" style=" width:60px;margin-right: 4px;">
          </el-image>
        </template>
      </custom-table-column> -->
      <!-- <custom-table-column prop="description" label="描述" min-width="220">
      </custom-table-column> -->
      <custom-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button  @click="handleEditNew(scope.row, ['id','is_edit'], () => handleEditCallBackSetFile({ fileField: 'warning_signs', row: scope.row }))"  type="text" size="small">编辑</el-button> -->
          <el-button  @click="handleEditNew(scope.row, ['id'])"  type="text" size="small">编辑</el-button>
          <el-button v-if="scope.row.is_edit" @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="风险等级" prop="level">
          <el-input v-model="ruleForm.level" :disabled="!ruleForm.is_edit" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="级别" prop="weight">
          <el-input-number v-model="ruleForm.weight" placeholder="请输入" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="检查周期" prop="inspection_period">
          <el-select v-model="ruleForm.inspection_period" placeholder="请选择" style="width:216px;">
            <el-option v-for="item in $store.state.periods" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="安全检查" prop="safety_check">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.safety_check"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="安全培训" prop="safety_training">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.safety_training"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="安全评估" prop="safety_assessment">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.safety_assessment"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="安全保障" prop="safety_guarantee">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.safety_guarantee"
            style="width:552px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="防护要点" prop="protection_points">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.protection_points"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="特种设备" prop="special_equipment">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.special_equipment"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="应急预案" prop="emergency_plan">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.emergency_plan"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="安全设施" prop="safety_facilities">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.safety_facilities"
            style="width:552px;"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="警示图示" prop="warning_signs" style="width:100%">
          <div style="width:552px;">
            <Uploadd ref="uploadd" fileFieldNameIn="warning_signs" :isMultiple="true" btnTitle="点击上传图片"
              @setFileList="setFileListMultiple" uploadType="image" @delFile="delUpFile"></Uploadd>
          </div>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.description"
            style="width:552px;"></el-input>
        </el-form-item> -->
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinUpload],
  data() {
    return {
      formInline: {
      },
      ruleForm: {
        level: '',
        weight: '',
        safety_check: '',
        safety_training: '',
        safety_guarantee: '',
        safety_assessment: '',
        // description: '',
        // protection_points: '',
        // special_equipment: '',
        // emergency_plan: '',
        // safety_facilities: '',
        // warning_signs: '',
        inspection_period:"每周1次",
        is_edit:true
      },
      rules: {
        level: [{ required: true, message: '请输入', trigger: 'blur' }],
        safety_check: [{ required: true, message: '请输入', trigger: 'blur' }],
        safety_training: [{ required: true, message: '请输入', trigger: 'blur' }],
        safety_guarantee: [{ required: true, message: '请输入', trigger: 'blur' }],
        safety_assessment: [{ required: true, message: '请输入', trigger: 'blur' }],
        inspection_period: [{ required: true, message: '请选择', trigger: 'change' }],
        //  description: [{ required: true, message: '请输入', trigger: 'blur' }],
        //   protection_points: [{ required: true, message: '请输入', trigger: 'blur' }],
        //   special_equipment: [{ required: true, message: '请输入', trigger: 'blur' }],
        //  emergency_plan: [{ required: true, message: '请输入', trigger: 'blur' }],
        //  safety_facilities: [{ required: true, message: '请输入', trigger: 'blur' }],
        //  warning_signs: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      uploadType: 'image',
      btnTitle: '点击上传警示图标',
      eqs: [],
      inputValue: '',
      inputVisible: false,
      safes: [],
      inputValue1: '',
      inputVisible1: false,
      fileFieldName: 'warning_icons',
    };
  },
  created() { },
  mounted() {
    // this.getList();
    // this.$store.dispatch('getDangerLevels');
  },
  watch: {
    // eqs: {
    //   handler: function (val) {
    //     this.ruleForm.special_equipment = val.join(',');
    //   },
    //   deep: false,
    // },
    // safes: {
    //   handler: function (val) {
    //     this.ruleForm.safety_facilities = val.join(',');
    //   },
    //   deep: false,
    // },
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },


    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/hazard-level-rules/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/hazard-level-rules/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/hazard-level-rules/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/hazard-level-rules/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleClose(tag, index) {
      this.eqs.splice(index, 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
        // this.$refs.saveTagInput.$children[0].$refs.input.focus();
      });
    },
    handleInputConfirm() {
      if (this.inputValue) {
        this.eqs.push(this.inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    handleClose1(tag, index) {
      this.safes.splice(index, 1);
    },

    showInput1() {
      this.inputVisible1 = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput1.$refs.input.focus();
        // this.$refs.saveTagInput.$children[0].$refs.input.focus();
      });
    },
    handleInputConfirm1() {
      if (this.inputValue1) {
        this.safes.push(this.inputValue1);
      }
      this.inputVisible1 = false;
      this.inputValue1 = '';
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
